import React from "react";
import withStyles from "components/common/wrappers/withStyles";

const TomoIQ = ({ color = "white", svgClassname }) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={svgClassname}
    >
      <g clipPath="url(#clip0_207_7)">
        <path
          d="M2.99998 14.6667V11.3333M2.99998 4.66667V1.33333M1.33331 3H4.66665M1.33331 13H4.66665M8.66665 2L7.51051 5.00591C7.32251 5.49473 7.22851 5.73914 7.08231 5.94473C6.95278 6.12693 6.79358 6.28613 6.61137 6.41569C6.40579 6.56187 6.16137 6.65587 5.67255 6.84387L2.66665 8L5.67255 9.15613C6.16137 9.34413 6.40579 9.43813 6.61137 9.58433C6.79358 9.71387 6.95278 9.87307 7.08231 10.0553C7.22851 10.2609 7.32251 10.5053 7.51051 10.9941L8.66665 14L9.82278 10.9941C10.0108 10.5053 10.1048 10.2609 10.251 10.0553C10.3805 9.87307 10.5397 9.71387 10.7219 9.58433C10.9275 9.43813 11.1719 9.34413 11.6607 9.15613L14.6666 8L11.6607 6.84387C11.1719 6.65587 10.9275 6.56187 10.7219 6.41569C10.5397 6.28613 10.3805 6.12693 10.251 5.94473C10.1048 5.73914 10.0108 5.49473 9.82278 5.00591L8.66665 2Z"
          stroke={color}
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_207_7">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default withStyles(TomoIQ);
